import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-inverter",
  "use": "dv-inverter-usage",
  "viewBox": "0 0 13.16 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.16 20\" id=\"dv-inverter\"><title>dv-inverter</title><g id=\"dv-inverter_Group-20\"><path id=\"dv-inverter_Combined-Shape\" d=\"M7.63,1.54h4.46v-1a.56.56,0,0,1,1.11,0v1h2.59a.79.79,0,0,1,.79.79V19.21a.79.79,0,0,1-.79.79H4.21a.79.79,0,0,1-.79-.79V2.32a.79.79,0,0,1,.79-.79H6.52v-1a.56.56,0,0,1,1.11,0Z\" transform=\"translate(-3.42)\" /><rect id=\"dv-inverter_Rectangle\" x=\"2.27\" y=\"4.32\" width=\"8.51\" height=\"3.85\" rx=\"0.79\" ry=\"0.79\" fill=\"#f1f3f5\" /><circle id=\"dv-inverter_Oval\" cx=\"6.54\" cy=\"16.9\" r=\"0.97\" fill=\"#f1f3f5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-inverter.svg
// module id = q/uf
// module chunks = 268